import { Heading, HopperProvider, Paragraph } from "@hopper-ui/components";
import { getDefaultLocale } from "@sg-protect/core";
import { ErrorLayout } from "@sg-protect/shell";

export function MaintenancePage() {
    return (
        <HopperProvider theme="sharegate" colorScheme="system" locale={getDefaultLocale()} withBodyStyle>
            <ErrorLayout>
                <Heading size="3xl" level={1} textAlign="center">
                    Scheduled maintenance in progress
                </Heading>
                <Paragraph textAlign="center">
                    ShareGate Protect is temporarily unavailable. We'll have everything back up and running as soon as
                    possible.
                </Paragraph>
            </ErrorLayout>
        </HopperProvider>
    );
}
